@if (checkUserToken()) {
  <div class="page">
    <h2>JSON Global Configurations</h2>
    <div class="row">
      <mat-form-field appearance="outline" class="fullwidth">
        <mat-label>Configurations</mat-label>
        <mat-select [(value)]="selectedConfig" (selectionChange)="onSelectedConfig()">
          <mat-option [value]="null">No Config</mat-option>
          @for (config of envConfigList; track config) {
            <mat-option [value]="config.auth_key">
              {{config.app_name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row buttons">
      <button mat-stroked-button color="warn" (click)="redeployBackend()">Restart Backend</button>
      @if (env === 'prod') {
        <button mat-stroked-button color="warn" (click)="redeployBackend(true)">Restart Backend Jobs</button>
      }
    </div>
    <div class="row compare">
      <mat-form-field appearance="outline">
        <mat-label>Env to Compare</mat-label>
        <mat-select [(value)]="envToCompare">
          <mat-option [value]="null">None</mat-option>
          @for (env of envList; track env) {
            <mat-option [value]="env.value">{{env.key}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" [disabled]="!envToCompare" (click)="compareEnvs()">Compare</button>
    </div>
    @if (keysExclusiveToCurrentEnv.length || keysExclusiveToComparedEnv.length) {
      <app-compared-json-configs
        [envToCompare]="getEnvKey()"
        [keysExclusiveToCurrentEnv]="keysExclusiveToCurrentEnv"
        [keysExclusiveToComparedEnv]="keysExclusiveToComparedEnv"
      ></app-compared-json-configs>
    }
    <form class="form" [formGroup]="form">
      <mat-form-field appearance="outline" class="json-field">
        <mat-label>JSON Global Configurations</mat-label>
        <app-json formControlName="jsonConfigForm" baseTable="teamConfigurations" fieldHint="jsonConfigForm"></app-json>
      </mat-form-field>
    </form>
    <div class="actions">
      <button mat-stroked-button color="primary" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="saveForm()" [disabled]="!selectedConfig">Save</button>
    </div>
  </div>
} @else {
  <p>You are not logged in, please login to access this page.</p>
}
